// Search Topic Start

document.addEventListener('DOMContentLoaded', () => {

  const topicSearh = document.querySelector('.help-center-topics .serchCenter input')

  const removePreviousResult = () => {
    const faqs = document.querySelectorAll('.help-center-topics .helpcenterSecGrid a');
    faqs.forEach((item) => {
      item.classList.remove('show');
      item.classList.remove('notFound');
    });
  };

  const getRightResult = (item) => {
    const faqs = document.querySelectorAll('.help-center-topics .helpcenterSecGrid a');

    const process = Array.from(faqs).filter((data) => {
      const title = data.querySelector('h3').textContent.toLowerCase();
      return title.includes(item);
    });

    console.log(process)

    faqs.forEach((item) => {
      item.classList.remove('show');
    });

    if (!process.length) {
      faqs.forEach((item) => {
        item.classList.add('notFound');
      });
    }

    process.forEach((item) => {
      item.classList.add('show');
    });

 

  };


  function handleInputChange() {

    if (topicSearh.value.trim() === '') {
      removePreviousResult()
    } else {
      getRightResult(topicSearh.value.trim().toLowerCase());
    }
  }

  topicSearh.addEventListener("input", handleInputChange);

});


// Inner Faq Start

document.addEventListener('DOMContentLoaded', () => {

  const field = document.querySelector(".serchCenter form input[type=text]");
  const subtitle = document.querySelector('.helpcenterHeading h2').innerText;

  const removePreviousResult = () => {
    const faqs = document.querySelectorAll('.helpCenterSec .accordion');
    faqs.forEach((item) => {
      item.classList.remove('show');
      item.classList.remove('notFound');
    });
  };

  const getRightResult = (item) => {
    const faqs = document.querySelectorAll('.helpCenterSec .accordion');

    const process = Array.from(faqs).filter((data) => {
      const title = data.querySelector('h3').textContent.toLowerCase();
      const info = data.querySelector('.accordion-content:not(:empty)').textContent.toLowerCase();
      return title.includes(item) || info.includes(item);
    });

    console.log(process);


    if (!process.length) {
      faqs.forEach((item) => {
        item.classList.add('notFound');
      });
    }


    process.forEach((item) => {
      item.classList.add('show');
    });

    const displayNameAndLength = document.querySelector('.helpcenterHeading>p');
    displayNameAndLength.innerHTML = `${process.length} search results for <strong>“${item}”</strong>`;

    document.querySelector('.breadcrumb .faqSearchWord').innerText = `“${item}”`;
    document.querySelector('.helpcenterHeading h2').innerText = "Search Results";
    console.log(item)
  };

  const removeBids = () => {
    const displayNameAndLength = document.querySelector('.helpcenterHeading>p');
    displayNameAndLength.innerHTML = '';
    document.querySelector('.breadcrumb .faqSearchWord').innerText = '';
    document.querySelector('.helpcenterHeading h2').innerText = subtitle;
  };

  function handleInputChange() {
    removePreviousResult();
    if (field.value.trim() === '') {
      removeBids();
    } else {
      getRightResult(field.value.trim().toLowerCase());
    }
  }

  function handleSearchButtonClick(event) {
    event.preventDefault();
    removePreviousResult();
    if (field.value.trim() === '') {
      removeBids();
    } else {
      getRightResult(field.value.trim().toLowerCase());
    }
  }

  document.querySelector(".serchCenter form button[type=submit]").addEventListener("click", handleSearchButtonClick);
  field.addEventListener("input", handleInputChange);

});
